import React from 'react';

import useTransformModelToProps from '@/hooks/use-transform-model-to-props';
import useStore from '@/state';
import getComponent from '@/state/selectors/exposer/get-component';
import { IStore } from '@/state/slices/typings';
import type { BasicComponentProps } from '@/typings/generic';

const withExposer = <T extends BasicComponentProps>(
	Component: React.FC<T>,
	key: string,
	itemsListKey?: string,
) => {
	const WithExposer = (props: T) => {
		const { $exposerSuffix } = props;

		const exposerKey = !$exposerSuffix ? key : `${key}_${$exposerSuffix}`;

		const StoredComponent = useStore((state: IStore) =>
			getComponent(state, exposerKey),
		);

		const SelectedComponent = StoredComponent ?? Component;

		const transformedProps = useTransformModelToProps(props, itemsListKey);

		return (
			<SelectedComponent
				{...transformedProps}
				$exposerSuffix={exposerKey}
			/>
		);
	};

	return WithExposer;
};

export default withExposer;
